import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import _ from "lodash";
import { Button } from "@dhis2/ui";
import InfoIcon from '@material-ui/icons/Info';

const ThyroidProfile = (props) => {
const basicTestData = Array.isArray(props?.basicTestData) ? props.basicTestData : [];

  const oBasicTests = {
    chart: {
        type: 'bar',
        backgroundColor: null,
        height:'320',
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['TSH', 'Free T4', 'Thyroid peroxidase antibody']
    },
    yAxis: {
        min: 0,
        title: {
            text: ''
        },
        labels: {
          enabled: false,
      },
    },
        credits: {
        enabled: false,
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'percent',
            dataLabels: {
                enabled: true
            }
        }
    },
    series: [
    {
        name: 'Above Range',
        color:"#ff779e",
        data: [
            {y:_.find(basicTestData,{indicatornames:"TSH-Above Range"})?(_.find(basicTestData,{indicatornames:"TSH-Above Range"}).counts):0, color:"#ff779e"}, 
            {y:_.find(basicTestData,{indicatornames:"Free T4-Above Range"})?(_.find(basicTestData,{indicatornames:"Free T4-Above Range"}).counts):0, color:"#ff779e"}, 
            {y:_.find(basicTestData,{indicatornames:"Thyroid peroxidase antibody-Above Range"})?(_.find(basicTestData,{indicatornames:"Thyroid peroxidase antibody-Above Range"}).counts):0, color:"#ff779e"}, 
        ]
    }, {
        name: 'Normal Range',
        color:"#00acb1",
        data: [
            {y:_.find(basicTestData,{indicatornames:"TSH-Normal Range"})?(_.find(basicTestData,{indicatornames:"TSH-Normal Range"}).counts):0, color:"#00acb1"}, 
            {y:_.find(basicTestData,{indicatornames:"Free T4-Normal Range"})?(_.find(basicTestData,{indicatornames:"Free T4-Normal Range"}).counts):0, color:"#00acb1"}, 
            {y:_.find(basicTestData,{indicatornames:"Thyroid peroxidase antibody-Normal Range"})?(_.find(basicTestData,{indicatornames:"Thyroid peroxidase antibody-Normal Range"}).counts):0, color:"#00acb1"}, 
        ]
    }, {
        name: 'Needs Attention',
        color:"#002060",
        data: [
            {y:_.find(basicTestData,{indicatornames:"TSH-Needs Attention"})?(_.find(basicTestData,{indicatornames:"TSH-Needs Attention"}).counts):0, color:"#002060"}, 
            {y:_.find(basicTestData,{indicatornames:"Free T4-Needs Attention"})?(_.find(basicTestData,{indicatornames:"Free T4-Needs Attention"}).counts):0, color:"#002060"}, 
            {y:_.find(basicTestData,{indicatornames:"Thyroid peroxidase antibody-Needs Attention"})?(_.find(basicTestData,{indicatornames:"Thyroid peroxidase antibody-Needs Attention"}).counts):0, color:"#002060"}, 
        ]
    }]
  };

  return(
    <div>
            <div className="main-second-section mb-2">            
            <div className="heading">
                <h4 className="mt-0 mb-0"></h4>
            </div>   
            <div className="main-icon">
                <InfoIcon className="info-icon"></InfoIcon>
            </div>                   
        </div>
        <HighchartsReact highcharts={Highcharts} options={oBasicTests} />
    </div>

);
};

export default ThyroidProfile;